export const CARD_TYPE = {
  MEDICARE: 'medicare',
  DVA: 'dva',
  NONE: 'none',
  NOT_WITH_ME: 'not with me',
};

export const CARD_TYPE_LABEL = {
  [CARD_TYPE.MEDICARE]: 'Medicare Card',
  [CARD_TYPE.DVA]: 'DVA Card',
  [CARD_TYPE.NONE]: 'No Healthcare or Medicare card',
  [CARD_TYPE.NOT_WITH_ME]:
    "I don't have my Medicare card with me (please send your card details to Telecare when you can)",
};

export const NO_REBATE_CARD_TYPES = [CARD_TYPE.NONE, CARD_TYPE.NOT_WITH_ME];
